// @ts-nocheck
import React, { FunctionComponent } from 'react';
import { FieldProps, getIn } from 'formik';

// MUI
import TextField, { TextFieldProps } from '@mui/material/TextField';

// Properties
import * as styles from './FormTextField.styles';

const FormTextField: FunctionComponent<FieldProps & TextFieldProps> = props => {
    const { disabled, error, helperText, field, form, ...rest } = props;

    const isTouched = getIn(form.touched, field.name);
    const errorMessage = getIn(form.errors, field.name);

    return (
        <TextField
            sx={styles.textField}
            variant="outlined"
            size="small"
            margin="normal"
            InputLabelProps={{
                shrink: true,
            }}
            disabled={disabled ?? form.isSubmitting}
            error={error ?? Boolean(isTouched && errorMessage)}
            helperText={helperText ?? ((isTouched && errorMessage) ? errorMessage : undefined)}
            {...rest}
            {...field}
        />
    );
};

export default FormTextField;
